/**
 * JobClose AI · Slice 2T · Levi 1.0 Intelligence
 * ---------------------------------------------------
 * composeIntakeStatusSentence(facts, t)
 *
 * Pure function. Given a set of intake facts and a translator `t`,
 * returns a natural, contractor-facing sentence describing what Levi
 * currently sees during Full Project intake.
 *
 * Contractor-facing copy only. No internal identifiers (INTAKE_INCOMPLETE,
 * READY_FOR_*, etc.) are ever composed here — those never appear in the
 * output.
 */

/**
 * @param {object} facts  - deriveLeviFacts output with context="full_project_intake"
 * @param {function} t    - translator (path, args?) => string
 * @returns {string}
 */
export function composeIntakeStatusSentence(facts, t) {
  const f = facts || {};

  // Contractor has not even entered a customer name yet.
  if (f.customer_name_present === false) {
    return t("levi_intake_coach.status.no_customer_name");
  }

  const narrative = f.intake_has_any_narrative === true;
  const hasEmail = f.customer_email_present === true;
  const hasPhone = f.customer_phone_present === true;
  const hasAddress = f.job_address_present === true;

  // Job address present but customer email missing (mentioned in the
  // authorization as a canonical natural sentence).
  if (hasAddress && !hasEmail) {
    return t("levi_intake_coach.status.address_but_no_email");
  }

  // Contractor has a name + at least one contact + some narrative — good.
  if (narrative && (hasEmail || hasPhone)) {
    return t("levi_intake_coach.status.ready");
  }

  // Contractor has a name but almost nothing else.
  if (!narrative) {
    return t("levi_intake_coach.status.need_more_detail");
  }

  // Narrative present but contact info still missing.
  if (!hasEmail && !hasPhone) {
    return t("levi_intake_coach.status.contact_missing");
  }

  // Default reassurance.
  return t("levi_intake_coach.status.ready");
}

export default composeIntakeStatusSentence;
